import * as PIXI from "pixi.js";
import {config} from "../../config";
import data from "../configs/data";
import {Button} from "../controlElements/Button";

export class BetPanel extends PIXI.Container {

    private currentValueIndex = 0;

    private readonly BET_TEXT_POSITION = new PIXI.Point(55, 0);
    private readonly BET_VALUE_POSITION = new PIXI.Point(55, 34);
    private readonly MINUS_BUTTON_POSITION = new PIXI.Point(-8, 34);
    private readonly PLUS_BUTTON_POSITION = new PIXI.Point(118, 34);
    private readonly VALUE_TEXT_STYLE: any = {
        fontSize: 20,
        fill: "#fff",
        fontFamily: "RobotoCondensedRegular",
    };
    private readonly TITLE_TEXT_STYLE: any = {
        fontSize: 17,
        fill: "#c8c7c7",
        fontFamily: "RobotoRegular",
        fontWeight: 600,
        letterSpacing: 1.6,
    };
    private readonly TILE_TEXT = "BET";

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private minus: Button;
    private plus: Button;
    private betText: PIXI.Text;
    private betValueText: PIXI.Text;

    constructor() {
        super();

        this.createAndAddBetTexts();
        this.initBetButtons();
    }

    public getBetValue(): number {
        return config.betValues[this.currentValueIndex];
    }

    public setMaxBetValue(): void {
        this.currentValueIndex = config.betValues.length - 1;
        this.update();
    }

    public enable(): void {
        this.update();
    }

    public addOnValueChangeListener(listener: Function): void {
        this.minus.subscribeOnClicked(() => {
            listener(this.getBetValue());
        });
        this.plus.subscribeOnClicked(() => {
            listener(this.getBetValue());
        });
    }

    public disable(): void {
        this.plus.enabled = false;
        this.minus.enabled = false;
    }

    private createAndAddBetTexts(): void {
        this.betText = new PIXI.Text(this.TILE_TEXT, this.TITLE_TEXT_STYLE);
        this.betText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.betText.position = this.BET_TEXT_POSITION;
        this.betValueText = new PIXI.Text(config.betValues[this.currentValueIndex].toFixed(config.betDisplayPrecision).toString(),
            this.VALUE_TEXT_STYLE);
        this.betValueText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.betValueText.position = this.BET_VALUE_POSITION;
        this.addChild(this.betText);
        this.addChild(this.betValueText);
    }

    private initBetButtons(): void {
        this.minus = new Button(data.images.minusButtonBase, data.images.minusButtonOnHover,
            data.images.minusButtonOnClick, data.images.minusButtonInActive, data.audios.buttonClicked);
        this.minus.position = this.MINUS_BUTTON_POSITION;
        this.minus.subscribeOnClicked(() => {
            this.currentValueIndex--;
            this.update();
        });
        this.addChild(this.minus);

        this.plus = new Button(data.images.plusButtonBase, data.images.plusButtonOnHover, data.images.plusButtonOnClick,
            data.images.plusButtonInActive, data.audios.buttonClicked);
        this.plus.position = this.PLUS_BUTTON_POSITION;
        this.plus.subscribeOnClicked(() => {
            this.currentValueIndex++;
            this.update();
        });
        this.minus.enabled = false;
        this.addChild(this.plus);
    }

    private update(): void {
        const me: BetPanel = this;
        me.betValueText.text = config.betValues[this.currentValueIndex].toFixed(config.betDisplayPrecision);
        if (this.currentValueIndex === 0) {
            me.minus.enabled = false;
            me.plus.enabled = true;
        } else if (this.currentValueIndex === config.betValues.length - 1) {
            me.plus.enabled = false;
            me.minus.enabled = true;
        } else {
            me.minus.enabled = true;
            me.plus.enabled = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/BetPanel.ts